import React from 'react';
import { Form, Input, Modal } from 'antd';
import { ReactElement } from 'react';

export type CommentModalProps = {
  showModal: boolean;
  setShowModal: (boolean) => void;
  title: string;
  onFinish: (comment: string) => void;
  onCancel?: () => void;
};

export default function CommentModal(props: CommentModalProps): ReactElement {
  const { showModal, setShowModal, title, onFinish } = props;

  const [form] = Form.useForm();

  const { TextArea } = Input;

  return (
    <Modal
      open={showModal}
      onCancel={() => {
        form.resetFields();
        props.onCancel && props.onCancel();
        setShowModal(false);
      }}
      onOk={() => form.submit()}
      closable={false}
      title={title}
    >
      <Form
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 19 }}
        form={form}
        onFinish={async () => {
          onFinish(form.getFieldValue('comment'));
          form.resetFields();
          setShowModal(false);
        }}
      >
        <Form.Item
          name={'comment'}
          label={'Comment'}
          rules={[{ required: true }, { whitespace: true }]}
          className="fullWidth"
        >
          <TextArea rows={4} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
